import { render, staticRenderFns } from "./Clues.vue?vue&type=template&id=680a9403&scoped=true"
import script from "./Clues.vue?vue&type=script&lang=js"
export * from "./Clues.vue?vue&type=script&lang=js"
import style0 from "./Clues.vue?vue&type=style&index=0&id=680a9403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a9403",
  null
  
)

export default component.exports